import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VipModify = _resolveComponent("VipModify")!
  const _component_UpdatePassword = _resolveComponent("UpdatePassword")!
  const _component_AuthExpired = _resolveComponent("AuthExpired")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VipModify),
    _createVNode(_component_UpdatePassword),
    _createVNode(_component_AuthExpired)
  ], 64))
}